import React from 'react'
import { H2, Subheading, BillboardText, Row, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeInfo } from '@fs/zion-icon'
import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_FOREGROUND_COLOR,
  DISABLED_TEXT_COLOR,
  REVIEWED_COLOR,
  IN_PROGRESS_COLOR,
} from '../../shared/utils/panelConstants'

const getHeaderColors = (editStep, reviewed) => {
  const returnVal = {
    iconColor: null,
    iconBackground: null,
    textColor: null,
  }

  if (editStep) {
    return {
      ...returnVal,
      iconBackground: IN_PROGRESS_COLOR,
    }
  }
  if (reviewed) {
    return {
      ...returnVal,
      iconBackground: REVIEWED_COLOR,
    }
  }
  return {
    iconColor: DISABLED_FOREGROUND_COLOR,
    iconBackground: DISABLED_BACKGROUND_COLOR,
    textColor: DISABLED_TEXT_COLOR,
  }
}

const AdditionalFactsHeader = ({ reviewed, editMode, setEditMode, disableEdit = false }) => {
  const [t] = useTranslation()
  const { iconColor, iconBackground, textColor } = getHeaderColors(editMode, reviewed)
  return (
    <Row gutters="xxs" alignItemsY="middle">
      <NoticeInfo size="sm" background={iconBackground} color={iconColor} />
      <BillboardText primaryColor={textColor} secondaryColor={textColor} growX>
        <H2 size="H5">
          {t('additional-facts-card.title', 'Additional Facts')}
          {(!reviewed || editMode) && (
            <Subheading>{t('additional-facts-card.subheading', 'Occupation, Marital Status, and More')}</Subheading>
          )}
        </H2>
      </BillboardText>
      {!editMode && reviewed && (
        <Button
          data-testid="additional-facts-card-edit-button"
          linkName="Additional Facts Edit Button"
          onClick={() => setEditMode(true)}
          disabled={disableEdit}
        >
          {t('additional-facts-card.edit.btn', 'Edit')}
        </Button>
      )}
    </Row>
  )
}
export default AdditionalFactsHeader
